/* ========================================
   BW PRODUCT GALLERY
======================================== */

(function () {

  function initGallery() {

    const gallery = document.querySelector('.bw-product-gallery');
    if (!gallery) return;

    const slides       = gallery.querySelectorAll('.bw-slide');
    const thumbs       = gallery.querySelectorAll('.bw-thumb');
    const thumbsMobile = gallery.querySelectorAll('.bw-thumb-mobile');
    const modal        = document.querySelector('.bw-gallery-modal');
    const modalImg     = document.querySelector('.bw-gallery-modal-image');
    const closeBtn     = document.querySelector('.bw-gallery-close');
    const slider       = gallery.querySelector('.bw-gallery-slider');
    const thumbsDesktop = gallery.querySelector('.bw-gallery-thumbnails');

    let currentIndex = 0;
    let totalSlides  = slides.length;

    /* ---------- ACTIVATION SLIDE ---------- */

    function goTo(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;

      slides.forEach(s => s.classList.remove('active'));
      thumbs.forEach(t => t.classList.remove('active'));
      thumbsMobile.forEach(t => t.classList.remove('active'));

      slides[index].classList.add('active');
      if (thumbs[index]) thumbs[index].classList.add('active');
      if (thumbsMobile[index]) thumbsMobile[index].classList.add('active');

      // scroll thumbnail desktop dans la vue (carousel vertical)
      if (thumbsDesktop && thumbs[index]) {
        thumbs[index].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      // scroll thumbnail mobile dans la vue (carousel horizontal)
      const mobileBar = gallery.querySelector('.bw-mobile-thumbnails');
      if (mobileBar && thumbsMobile[index]) {
        thumbsMobile[index].scrollIntoView({ inline: 'nearest', behavior: 'smooth' });
      }

      currentIndex = index;
    }

    /* ---------- THUMBNAILS DESKTOP ---------- */

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {
        goTo(parseInt(thumb.dataset.index, 10));
      });
    });

    /* ---------- THUMBNAILS MOBILE ---------- */

    thumbsMobile.forEach(thumb => {
      thumb.addEventListener('click', () => {
        goTo(parseInt(thumb.dataset.index, 10));
      });
    });

    /* ---------- SWIPE MOBILE ---------- */

    let touchStartX = 0;
    let touchStartY = 0;
    let isDragging  = false;

    slider.addEventListener('touchstart', e => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isDragging  = true;
    }, { passive: true });

    slider.addEventListener('touchmove', e => {
      if (!isDragging) return;
      const dx = Math.abs(e.touches[0].clientX - touchStartX);
      const dy = Math.abs(e.touches[0].clientY - touchStartY);
      // si swipe horizontal dominant, bloquer le scroll vertical
      if (dx > dy) e.preventDefault();
    }, { passive: false });

    slider.addEventListener('touchend', e => {
      if (!isDragging) return;
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      isDragging = false;

      // swipe horizontal uniquement si dominant
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
        dx < 0 ? goTo(currentIndex + 1) : goTo(currentIndex - 1);
      }
    });

    /* ---------- MODAL ZOOM (desktop uniquement) ---------- */

    function openModal(src, alt) {
      modalImg.src = src;
      modalImg.alt = alt || '';
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('open');
      document.body.style.overflow = '';
      // reset src après transition
      setTimeout(() => { modalImg.src = ''; }, 300);
    }

    // clic sur image principale — desktop seulement
    slides.forEach(slide => {
      const img = slide.querySelector('.bw-main-image');
      if (!img) return;
      img.addEventListener('click', () => {
        if (window.innerWidth <= 990) return;
        const thumb = thumbs[currentIndex];
        const fullSrc = thumb ? thumb.dataset.full : img.src;
        openModal(fullSrc, img.alt);
      });
    });

    // fermeture modal
    closeBtn && closeBtn.addEventListener('click', closeModal);

    modal && modal.addEventListener('click', e => {
      if (e.target === modal) closeModal();
    });

    document.addEventListener('keydown', e => {
      if (!modal.classList.contains('open')) return;
      if (e.key === 'Escape') closeModal();
      if (e.key === 'ArrowRight') { closeModal(); setTimeout(() => { goTo(currentIndex + 1); openModalCurrent(); }, 310); }
      if (e.key === 'ArrowLeft')  { closeModal(); setTimeout(() => { goTo(currentIndex - 1); openModalCurrent(); }, 310); }
    });

    function openModalCurrent() {
      const img   = slides[currentIndex] && slides[currentIndex].querySelector('.bw-main-image');
      const thumb = thumbs[currentIndex];
      if (!img) return;
      openModal(thumb ? thumb.dataset.full : img.src, img.alt);
    }

    /* ---------- INIT ---------- */
    goTo(0);
  }

  // attendre que le DOM soit prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else {
    initGallery();
  }

})();